(function(){
    angular.module('iq_common', []);
})();